<img
  class="pointer"
  (click)="session.goToHome()"
  src="assets/images/logo.webp"
  width="45px"
  height="55px"
/>
